'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _core = require('@material-ui/core');

var _form = require('../../schema/component/form.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */


// Lazy Load
var CheckIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Check');
});
var CancelIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/Cancel');
});

var schema = _form.properties.input.properties;

var useStyles = (0, _core.makeStyles)({
  container: {
    width: '100%',
    // Root
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--outline)'
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
      height: '54px'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--primary-500)'
    },
    // Input
    '& .MuiOutlinedInput-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '&:hover .MuiOutlinedInput-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '& .MuiFilledInput-underline:after': {
      borderBottom: '2px solid var(--primary-500)'
    },
    // Label
    '& .MuiInputLabel-outlined': {
      color: 'var(--onsurface-medium-emphasis)',
      marginTop: '-4px'
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      background: 'var(--onprimary-high-emphasis)',
      color: 'var(--primary-500) !important',
      fontSize: '14px',
      padding: '0px 8px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'var(--primary-900) !important'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      marginTop: '0px'
    },
    '& .MuiInputLabel-shrink.MuiInputLabel-outlined.MuiFormLabel-filled': {
      background: 'var(--onprimary-high-emphasis)',
      padding: '0px 8px'
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl legend': {
      maxWidth: '0px'
    },
    '& .MuiInputLabel-filled': {
      color: 'var(--onsurface-medium-emphasis)',
      marginTop: '-4px'
    },
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      marginTop: '0px'
    },
    '& .MuiInputLabel-root': {
      color: 'var(--onsurface-medium-emphasis)',
      marginTop: '-4px'
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      marginTop: '0px'
    },
    // Error
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--error)',
      borderWidth: '2px'
    },
    '& .MuiInputLabel-outlined.Mui-error': {
      color: 'var(--error) !important'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: 'var(--error)'
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: 'var(--error) !important'
    },
    '& .MuiFilledInput-underline.Mui-error:after': {
      borderBottomColor: 'var(--error)'
    },
    // Standard
    '& .MuiInputBase-root .MuiInputBase-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '& .MuiInput-underline:after': {
      borderColor: 'var(--outline)'
    },
    '& .MuiInput-underline.Mui-focused:after': {
      borderColor: 'var(--primary-500)'
    },
    '& .MuiInput-underline.MuiInputBase-adornedEnd:before': {
      borderBottom: '1px solid var(--primary-500)'
    },
    '& .MuiInput-underline.Mui-error:after': {
      borderBottomColor: 'var(--error)'
    },
    '& .MuiInput-underline .MuiSvgIcon-root.icon-filled': {
      color: 'var(--primary-700)'
    },
    '& .MuiInput-underline .MuiSvgIcon-root.icon-error': {
      color: 'var(--error)'
    },
    // With Adortment
    '& .MuiIconButton-root': {
      padding: '10px'
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0px'
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '0px'
    },
    '& [data-adornment-error="false"]': {
      color: 'var(--onsurface-disable)'
    },
    '& [data-adornment-error="true"]': {
      color: 'var(--error)'
    },
    '& .MuiOutlinedInput-root.Mui-focused [data-adornment-error="false"]': {
      color: 'var(--primary-500)'
    },
    '& .MuiFilledInput-adornedEnd': {
      paddingRight: '0px'
    },
    '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: '0px'
    },
    '& .MuiFilledInput-root.Mui-focused [data-adornment-error="false"]': {
      color: 'var(--primary-500)'
    },
    '& .MuiInput-root.Mui-focused [data-adornment-error="false"]': {
      color: 'var(--primary-500)'
    }
  }
});

function NumberFormatCustom(props) {
  var formatInput = props.formatInput,
      inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, ['formatInput', 'inputRef', 'onChange']);

  return _react2.default.createElement(_reactNumberFormat2.default, _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: '.',
    decimalSeparator: ',',
    isNumericString: true,
    prefix: formatInput === 'number' ? 'Rp ' : '',
    step: 1
  }));
}

NumberFormatCustom.propTypes = {
  formatInput: _propTypes2.default.string.isRequired,
  inputRef: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

var Input = function Input(_ref) {
  var adornmentAction = _ref.adornmentAction,
      AdornmentIcon = _ref.AdornmentIcon,
      adornmentVariant = _ref.adornmentVariant,
      className = _ref.className,
      error = _ref.error,
      formatInput = _ref.formatInput,
      id = _ref.id,
      value = _ref.value,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ['adornmentAction', 'AdornmentIcon', 'adornmentVariant', 'className', 'error', 'formatInput', 'id', 'value', 'variant']);

  var classes = useStyles();
  var IconAdornment = value && error === '' ? CheckIcon : CancelIcon;

  var getInputProps = function getInputProps() {
    if (['validation', 'custom'].includes(adornmentVariant)) {
      return {
        endAdornment: _react2.default.createElement(
          _core.InputAdornment,
          { position: 'start' },
          _react2.default.createElement(
            _core.IconButton,
            null,
            adornmentVariant === 'custom' && AdornmentIcon && _react2.default.createElement(AdornmentIcon, { onClick: adornmentAction }),
            adornmentVariant === 'validation' && value && _react2.default.createElement(
              _react.Suspense,
              { fallback: _react2.default.createElement('div', null) },
              _react2.default.createElement(IconAdornment, {
                onClick: adornmentAction,
                'data-adornment-error': error !== ''
              })
            )
          )
        )
      };
    }

    return null;
  };

  return _react2.default.createElement(_core.TextField, _extends({
    className: classes.container + ' ' + className,
    id: id,
    error: error !== '',
    helperText: error,
    inputProps: { formatInput: formatInput }
    // eslint-disable-next-line react/jsx-no-duplicate-props
    , InputProps: ['number', 'numeric'].includes(formatInput) ? {
      inputComponent: NumberFormatCustom
    } : getInputProps(),
    InputLabelProps: {
      width: '10px'
    },
    variant: variant,
    value: value
  }, props));
};

exports.Input = Input;
Input.defaultProps = {
  adornmentAction: schema.adornmentAction,
  AdornmentIcon: schema.AdornmentIcon,
  adornmentVariant: schema.adornmentVariant,
  className: schema.className,
  error: schema.error,
  formatInput: schema.formatInput,
  id: schema.id,
  value: schema.value,
  variant: schema.variant
};

Input.propTypes = {
  adornmentAction: _propTypes2.default.func,
  AdornmentIcon: _propTypes2.default.node,
  adornmentVariant: _propTypes2.default.string,
  className: _propTypes2.default.string,
  error: _propTypes2.default.string,
  formatInput: _propTypes2.default.string,
  id: _propTypes2.default.string,
  value: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

exports.default = Input;